export type ToastTone = 'ok' | 'warn' | 'bad' | 'info'

export interface ToastData {
  id: string
  text: string
  tone: ToastTone
}

const DOT_CLASSES: Record<ToastTone, string> = {
  ok: 'bg-ok',
  warn: 'bg-warn',
  bad: 'bg-bad',
  info: 'bg-info',
}

export function Toast({ toast }: { toast: ToastData }) {
  return (
    <div
      role="status"
      className="pointer-events-none flex items-center gap-2 rounded-full border border-subtle bg-elevated px-3 py-2 text-[12px] text-hi shadow-toast"
    >
      <span className={['h-[6px] w-[6px] rounded-full', DOT_CLASSES[toast.tone]].join(' ')} />
      {toast.text}
    </div>
  )
}

/** Bottom-centre stack, per docs/design-handoff/README.md "Modals" — non-interactive, 4.2s each (the timer lives with whoever calls dismissToast). */
export function ToastStack({ toasts }: { toasts: ToastData[] }) {
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex flex-col items-center gap-2">
      {toasts.map((t) => (
        <Toast key={t.id} toast={t} />
      ))}
    </div>
  )
}
